module.exports = __webpack_public_path__ + "img/user-placeholder.d6e693d6.svg";